"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UIAlert = _interopRequireDefault(require("./UIAlert"));

var UIFloatingAlert = _react.default.createClass({
  displayName: "UIFloatingAlert",
  propTypes: (0, _extends2.default)({}, _UIAlert.default.propTypes),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _UIAlert.default.defaultProps, {
      closeable: true
    });
  },
  getClassName: function getClassName() {
    var className = this.props.className;
    return (0, _classNames.default)('private-floating-alert', className);
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        closeable = _this$props.closeable,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "closeable"]);
    return _react.default.createElement(_UIAlert.default, (0, _extends2.default)({}, rest, {
      className: this.getClassName({
        className: className
      }),
      closeable: closeable
    }), children);
  }
});

var _default = UIFloatingAlert;
exports.default = _default;
module.exports = exports.default;